module.exports = __webpack_public_path__ + "static/media/Test32.ea6efda5.bmp";